/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Permissions_Select_GroupsInputs */



/**
* | output |
* | --- |
* | "Select groups that can access this guide:" |
*
* @param {Knp_Manager_Permissions_Select_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_select_groups = /** @type {((inputs?: Knp_Manager_Permissions_Select_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_Select_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez les groupes qui peuvent accéder à ce guide :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie Gruppen aus, die auf diesen Leitfaden zugreifen können:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i gruppi che possono accedere a questa guida:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группы, которым доступен этот справочник:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione grupos que pueden acceder a esta guía:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择可以访问本指南的群体：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このガイドにアクセスできるグループを選択してください:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन समूहों का चयन करें जो इस मार्गदर्शिका तक पहुंच सकते हैं:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os grupos que podem acessar este guia:")
	return /** @type {LocalizedString} */ ("Select groups that can access this guide:")
});